import { resolveUpiAppConfigLogoUrl } from './mfCdnAssetUrl'

export type UpiAppConfigEntry = {
  name: string
  logoPath: string
}

/** Known UPI app package ids / iOS scheme ids → display name and logo (matches native UpiApp enum). */
const UPI_APP_CONFIG: Record<string, UpiAppConfigEntry> = {
  default: { name: 'Upi', logoPath: '/images/payments/default_upi.png' },

  'com.google.android.apps.nbu.paisa.user': { name: 'Google Pay', logoPath: '/images/payments/googlepe.png' },
  'com.phonepe.app': { name: 'PhonePe', logoPath: '/images/payments/phonepe.png' },
  'net.one97.paytm': { name: 'PayTM', logoPath: '/images/payments/paytm.png' },
  'com.paytmmall': { name: 'Paytm Mall', logoPath: '/images/payments/paytm.png' },
  'in.org.npci.upiapp': { name: 'BHIM', logoPath: '/images/payments/bhim.png' },
  'in.amazon.mshop.android.shopping': { name: 'Amazon Pay', logoPath: '/images/payments/amazon_pay.png' },
  'com.csam.icici.bank.imobile': { name: 'ICICI Imobile', logoPath: '/images/payments/ICIC.png' },
  'com.sbi.upi': { name: 'BHIM SBI Pay', logoPath: '/images/payments/default_upi.png' },
  'com.myairtelapp': { name: 'MyAirtel App', logoPath: '/images/payments/default_upi.png' },
  'com.icicibank.pockets': { name: 'ICICI Pockets', logoPath: '/images/payments/default_upi.png' },
  'com.icici.pockets': { name: 'ICICI Pockets', logoPath: '/images/payments/default_upi.png' },
  'com.auank.au0101': { name: 'AU 0101', logoPath: '/images/payments/default_upi.png' },
  'com.aubank.au0101': { name: 'AU 0101', logoPath: '/images/payments/default_upi.png' },
  'com.canarabank.mobility': { name: 'Canara ai1', logoPath: '/images/payments/default_upi.png' },
  'com.fedmobile': { name: 'FedMobile', logoPath: '/images/payments/default_upi.png' },
  'com.federalbank.fedmobile': { name: 'FedMobile', logoPath: '/images/payments/default_upi.png' },
  'com.msf.indusind': { name: 'IndusInd Indie', logoPath: '/images/payments/default_upi.png' },
  'com.indusind.indie': { name: 'IndusInd Indie', logoPath: '/images/payments/default_upi.png' },
  'com.hdfcbank.payzapp': { name: 'PayZapp', logoPath: '/images/payments/default_upi.png' },
  'com.sbi.lotusintouch': { name: 'SBI YONO', logoPath: '/images/payments/default_upi.png' },
  'com.axisbank.axismobile': { name: 'Axis Mobile', logoPath: '/images/payments/default_upi.png' },
  'com.snapwork.hdfc': { name: 'HDFC Snapwork', logoPath: '/images/payments/default_upi.png' },
  'com.enstage.wibmo.hdfc': { name: 'HDFC Wibmo', logoPath: '/images/payments/default_upi.png' },
  'com.mobikwik_new': { name: 'Mobikwik', logoPath: '/images/payments/default_upi.png' },
  'com.upi.axispay': { name: 'Axis Pay', logoPath: '/images/payments/default_upi.png' },
  'com.axis.mobile': { name: 'Axis Mobile', logoPath: '/images/payments/default_upi.png' },
  'com.freecharge.android': { name: 'Freecharge', logoPath: '/images/payments/default_upi.png' },
  'com.infrasoft.uboi': { name: 'Union Ease', logoPath: '/images/payments/default_upi.png' },
  'com.tatadigital.tcp': { name: 'Tata Neu', logoPath: '/images/payments/default_upi.png' },
  'com.euronet.iobupi': { name: 'BHIM IOB', logoPath: '/images/payments/default_upi.png' },
  'com.samsung.android.spaymini': { name: 'Samsung SPayMini', logoPath: '/images/payments/default_upi.png' },
  'com.samsung.android.spay': { name: 'Samsung SPay', logoPath: '/images/payments/default_upi.png' },
  'com.dreamplug.androidapp': { name: 'CRED', logoPath: '/images/payments/cred.png' },
  'com.bankofbaroda.upi': { name: 'Bank of Baroda', logoPath: '/images/payments/default_upi.png' },
  'com.whatsapp.w4b': { name: 'WhatsApp Business', logoPath: '/images/payments/default_upi.png' },
  'com.fss.pnbpsp': { name: 'PNB', logoPath: '/images/payments/default_upi.png' },
  'com.fss.unbipsp': { name: 'UNBI', logoPath: '/images/payments/default_upi.png' },
  'com.mycompany.kvb': { name: 'KVB MyCompany', logoPath: '/images/payments/default_upi.png' },
  'com.fss.vijayapsp': { name: 'Vijaya Bank', logoPath: '/images/payments/default_upi.png' },
  'com.dena.upi.gui': { name: 'Dena', logoPath: '/images/payments/default_upi.png' },
  'com.fss.jnkpsp': { name: 'Jammu and Kashmir', logoPath: '/images/payments/default_upi.png' },
  'com.olive.kotak.upi': { name: 'Kotak', logoPath: '/images/payments/default_upi.png' },
  'com.bsb.hike': { name: 'Hike', logoPath: '/images/payments/default_upi.png' },
  'com.fss.idfcpsp': { name: 'IDFC PSP', logoPath: '/images/payments/default_upi.png' },
  'com.yesbank': { name: 'Yes Bank', logoPath: '/images/payments/default_upi.png' },
  'com.microsoft.mobile.polymer': { name: 'Polymer', logoPath: '/images/payments/default_upi.png' },
  'com.finopaytech.bpayfino': { name: 'Fino', logoPath: '/images/payments/default_upi.png' },
  'com.mgs.obcbank': { name: 'Oriental Bank of Commerce', logoPath: '/images/payments/default_upi.png' },
  'com.upi.federalbank.org.lotza': { name: 'Federal Bank', logoPath: '/images/payments/default_upi.png' },
  'com.mgs.induspsp': { name: 'Indus Bank', logoPath: '/images/payments/default_upi.png' },
  'ai.wizely.android': { name: 'Wizely', logoPath: '/images/payments/default_upi.png' },
  'com.olive.dcb.upi': { name: 'DCB', logoPath: '/images/payments/default_upi.png' },
  'com.mgs.yesmerchantnative.prod': { name: 'Yes Merchant', logoPath: '/images/payments/default_upi.png' },
  'com.dbs.in.digitalbank': { name: 'DBS', logoPath: '/images/payments/default_upi.png' },
  'com.rblbank.mobank': { name: 'RBL MoBank', logoPath: '/images/payments/default_upi.png' },
  'in.chillr': { name: 'Chillr', logoPath: '/images/payments/default_upi.png' },
  'com.citrus.citruspay': { name: 'CitrusPay', logoPath: '/images/payments/default_upi.png' },
  'com.sibmobile': { name: 'South Indian Bank', logoPath: '/images/payments/default_upi.png' },
  'com.mipay.wallet.in': { name: 'MI Pay', logoPath: '/images/payments/default_upi.png' },
  'com.whatsapp': { name: 'WhatsApp Pay', logoPath: '/images/payments/default_upi.png' },
  'com.truecaller': { name: 'Truecaller', logoPath: '/images/payments/default_upi.png' },
  'com.olacabs.customer': { name: 'Ola', logoPath: '/images/payments/default_upi.png' },
  'com.gbwhatsapp': { name: 'GB WhatsApp', logoPath: '/images/payments/default_upi.png' },
  'com.msf.angelmobile': { name: 'Angel Mobile', logoPath: '/images/payments/default_upi.png' },
  'com.fundsindia': { name: 'Funds India', logoPath: '/images/payments/default_upi.png' },
  'com.muthootfinance.imuthoot': { name: 'iMuthoot', logoPath: '/images/payments/default_upi.png' },
  'com.angelbroking.angelwealth': { name: 'Angel Wealth', logoPath: '/images/payments/default_upi.png' },
  'org.altruist.bajajexperia': {
    name: 'Bajaj Finserv - Instant Loans,Credit Card,EMI Card',
    logoPath: '/images/payments/default_upi.png'
  },
  'in.bajajfinservmarkets.app': { name: 'Bajaj Finserv MARKETS', logoPath: '/images/payments/default_upi.png' },
  'money.super.payments': { name: 'Supermoney', logoPath: '/images/payments/super_money.png' },
  /** iOS URL schemes reported for super.money (native Android key is money.super.payments). */
  super: { name: 'Supermoney', logoPath: '/images/payments/super_money.png' },
  supermoney: { name: 'Supermoney', logoPath: '/images/payments/super_money.png' },
  'com.naviapp': { name: 'Navi UPI', logoPath: '/images/payments/navi.png' },
  'club.cred.app': { name: 'Cred', logoPath: '/images/payments/cred.png' },
  'com.amazon.amazon': { name: 'Amazon pay', logoPath: '/images/payments/amazon_pay.png' },
  'com.popclub.android': { name: 'PopClub', logoPath: '/images/payments/popclub.png' },
  'com.version1': { name: 'PNB ONE', logoPath: '/images/payments/default_upi.png' },
  'indwin.c3.shareapp': { name: 'Slice', logoPath: '/images/payments/default_upi.png' },

  phonepe: { name: 'PhonePe', logoPath: '/images/payments/phonepe.png' },
  google_pay: { name: 'Google Pay', logoPath: '/images/payments/googlepe.png' },
  tez: { name: 'Google Pay', logoPath: '/images/payments/googlepe.png' },
  paytmmp: { name: 'PayTm', logoPath: '/images/payments/paytm.png' },
  paytm: { name: 'PayTm', logoPath: '/images/payments/paytm.png' },
  cred: { name: 'CRED', logoPath: '/images/payments/cred.png' },
  navi: { name: 'Navi UPI', logoPath: '/images/payments/navi.png' },
  bhim: { name: 'BHIM', logoPath: '/images/payments/bhim.png' },
  popclubapp: { name: 'PopClub', logoPath: '/images/payments/popclub.png' },

  axispay: { name: 'Axis Pay', logoPath: '/images/payments/default_upi.png' },
  au0101: { name: 'AU 0101', logoPath: '/images/payments/default_upi.png' },
  canaraai1: { name: 'Canara ai1', logoPath: '/images/payments/default_upi.png' },
  fedmobile: { name: 'FedMobile', logoPath: '/images/payments/default_upi.png' },
  pockets: { name: 'ICICI Pockets', logoPath: '/images/payments/default_upi.png' },
  indie: { name: 'IndusInd Indie', logoPath: '/images/payments/default_upi.png' },
  payzapp: { name: 'PayZapp', logoPath: '/images/payments/default_upi.png' },
  yonosbi: { name: 'SBI YONO', logoPath: '/images/payments/default_upi.png' },
  freecharge: { name: 'Freecharge', logoPath: '/images/payments/default_upi.png' },
  tnupi: { name: 'Tata Neu', logoPath: '/images/payments/default_upi.png' }
}

/** UPI deep-link scheme → config key (iOS schemes and common Android intent schemes). */
const UPI_SCHEME_TO_CONFIG_KEY: Record<string, string> = {
  phonepe: 'phonepe',
  gpay: 'google_pay',
  tez: 'tez',
  google_pay: 'google_pay',
  paytm: 'paytm',
  paytmmp: 'paytmmp',
  bhim: 'bhim',
  amazonpay: 'com.amazon.amazon',
  cred: 'cred',
  credpay: 'cred',
  navi: 'navi',
  popclub: 'popclubapp',
  popclubapp: 'popclubapp',
  super: 'super',
  supermoney: 'supermoney'
}

const DEFAULT_UPI_APP_CONFIG = UPI_APP_CONFIG.default

/**
 * UPI apps blocked from payment intent and autopay pickers.
 * Android package names + iOS bundle ids / URL schemes from product blocklist.
 */
const BLOCKED_UPI_APP_KEYS = new Set([
  'com.auank.au0101',
  'com.aubank.au0101',
  'com.ausmallfinancebank.amb',
  'au0101',
  'com.axis.mobile',
  'com.upi.axispay',
  'com.axisbank.axismobile',
  'axispay',
  'com.canarabank.mobility',
  'canaraai1',
  'com.fedmobile',
  'com.federalbank.fedmobile',
  'fedmobile',
  'com.icici.pockets',
  'com.icicibank.pockets',
  'pockets',
  'com.msf.indusind',
  'com.indusind.indie',
  'indwin.c3.shareapp', // slice
  'indie',
  'com.enstage.wibmo.hdfc',
  'com.hdfcbank.payzapp',
  'payzapp',
  'com.sbi.lotusintouch',
  'sbiyono',
  'yonosbi',
  'com.samsung.android.spay',
  'com.rblbank.mobank',
  'com.infrasoft.uboi',
  'com.tatadigital.tcp',
  'tnupi',
  'com.freecharge.android',
  'freecharge',
  'com.euronet.iobupi',
  'com.sbi.upi',
  'com.whatsapp',
  'com.version1',
  'whatsapp',
  'slice-upi',
  'com.fampay.in',
  'in.fampay.app',
  'com.snapwork.hdfc',
  'in.irisbyyes.app',
  'com.msf.kbank.mobile',
  'kotakbank',
  'com.idfcfirstbank.optimus',
  'com.popclub.android',
  'popclubapp',
  'popclub',
  'com.mobikwik_new',
  'mobikwik',
  'com.nextbillion.groww',
  'growwapp'
])

function normalizeUpiAppKey(value: string): string {
  return value.trim().toLowerCase()
}

/** True when a UPI app must not appear in payment intent or autopay pickers (Android + iOS ids). */
export function isBlockedUpiApp(packageName: string | null | undefined): boolean {
  const key = normalizeUpiAppKey(packageName ?? '')
  if (!key) return false
  return BLOCKED_UPI_APP_KEYS.has(key)
}

export function getUpiAppConfigByPackage(packageName: string | null | undefined): UpiAppConfigEntry {
  const key = normalizeUpiAppKey(packageName ?? '')
  if (key && UPI_APP_CONFIG[key]) {
    return UPI_APP_CONFIG[key]
  }
  return DEFAULT_UPI_APP_CONFIG
}

export function getUpiAppConfigByScheme(scheme: string | null | undefined): UpiAppConfigEntry | null {
  const normalizedScheme = normalizeUpiAppKey(scheme ?? '')
  if (!normalizedScheme) return null

  const configKey = UPI_SCHEME_TO_CONFIG_KEY[normalizedScheme]
  if (configKey && UPI_APP_CONFIG[configKey]) {
    return UPI_APP_CONFIG[configKey]
  }

  if (UPI_APP_CONFIG[normalizedScheme]) {
    return UPI_APP_CONFIG[normalizedScheme]
  }

  return null
}

/** Android package + iOS schemes for super.money — native iOS logo URLs fail to load in webview. */
const SUPERMONEY_UPI_APP_KEYS = new Set(['money.super.payments', 'super', 'supermoney'])

function isSupermoneyUpiApp(packageName: string | null | undefined): boolean {
  const key = normalizeUpiAppKey(packageName ?? '')
  return Boolean(key) && SUPERMONEY_UPI_APP_KEYS.has(key)
}

/** Fills missing name/logo from static config; native values take precedence when present. */
export function resolveUpiAppDisplay(
  packageName: string | null | undefined,
  options?: { name?: string | null; logoUrl?: string | null }
): { name: string; logoUrl: string } {
  const config = getUpiAppConfigByPackage(packageName)
  const nativeName = options?.name?.trim() ?? ''
  const nativeLogo = options?.logoUrl?.trim() ?? ''
  const configLogoUrl = resolveUpiAppConfigLogoUrl(config.logoPath)

  // Supermoney: prefer CDN config — iOS native icon URLs never load in the webview.
  if (isSupermoneyUpiApp(packageName)) {
    return {
      name: nativeName || config.name,
      logoUrl: configLogoUrl
    }
  }

  return {
    name: nativeName || config.name,
    logoUrl: nativeLogo || configLogoUrl
  }
}
